"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_calendar__1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "67f1e53b-ec98-41a6-9813-683816f5a1bc",
    x1: 59.82,
    y1: 28.29,
    x2: 179.23,
    y2: 147.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "calendar-1-hi"), /*#__PURE__*/React.createElement("g", {
    id: "80ee0543-8357-4b56-994d-ea57e8773f01",
    "data-name": "calendar-1-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b76daa3a-2c15-4e09-91ec-2f92d04c3185",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "55100383-a568-414b-8029-b24886285061",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ee8bb0f0-96e4-45c8-b9a1-be472dfbef9a",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4708f940-0c6c-461d-94a5-37de02a29d03",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9d3f3ea-c663-4232-9eac-ab16399f5e64",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46a52da6-d638-4512-aa96-a412befb9158",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bf969bd2-392c-4080-b84b-40cebcf90c73",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V64H24Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,24H32a8,8,0,0,0-8,8V64H168V32A8,8,0,0,0,160,24ZM52,40a4,4,0,1,1,4-4A4,4,0,0,1,52,40Zm88,0a4,4,0,1,1,4-4A4,4,0,0,1,140,40Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 144,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,52,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,140,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "63aa17d5-023e-49c3-801d-ac290288aed1",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,64.13l-123.33-.2h-20v.59L128.34,168H152a19,19,0,0,0,4.24-.37,16.3,16.3,0,0,0,8.52-5.64,15.86,15.86,0,0,0,3.39-9.81V64.79Z",
    transform: "translate(0 0)",
    opacity: 0.1,
    fill: "url(#67f1e53b-ec98-41a6-9813-683816f5a1bc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.89,24.63A7.92,7.92,0,0,1,31.19,24,7.92,7.92,0,0,0,28.89,24.63Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.54,25.37a8.1,8.1,0,0,0-1.7,1.55A8.1,8.1,0,0,1,27.54,25.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "M95.88,137.46V92.09l-11.4,7.65-3-4.38L96.68,84.83H102v52.62Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })));
}

var _default = ic_calendar__1;
exports.default = _default;